// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

interface EligibleInstrumentsProps {
  admin: string;
  id: string;
  amount: string;
  uuid: string;
}
export const useEligibleInstruments = (initial?: EligibleInstrumentsProps[]) => {
  const [eligibleInstruments, setList] = useState<EligibleInstrumentsProps[]>(
    initial && initial.length > 0 ? initial : [{ admin: '', id: '', amount: '', uuid: uuidv4() }],
  );

  const addEntry = React.useCallback(() => {
    setList((prev) => [...prev, { admin: '', id: '', amount: '', uuid: uuidv4() }]);
  }, []);

  const updateEntry = React.useCallback((index: number, field: string, value: string) => {
    setList((prev) => prev.map((entry, i) => (i === index ? { ...entry, [field]: value } : entry)));
  }, []);
  const onChange = (id: string, admin: string, index?: number) => {
    setList((prev) => prev.map((entry, i) => (i === index ? { ...entry, admin, id } : entry)));
  };

  const removeEntry = React.useCallback((index: number) => {
    setList((prev) => prev.filter((_, i) => i !== index));
  }, []);
  const resetList = React.useCallback(() => {
    setList([{ admin: '', id: '', amount: '', uuid: uuidv4() }]);
  }, []);
  return {
    eligibleInstruments,
    setList,
    addEntry,
    updateEntry,
    removeEntry,
    onChange,
    resetList,
  };
};
